import Vue from 'vue';
import VueRouter from 'vue-router';
import VueParticles from 'vue-particles';
import VueScrollTo from 'vue-scrollto';
import VueAnalytics from 'vue-analytics';
import AOS from 'aos'
import 'aos/dist/aos.css'
import App from './App.vue';
import router from './routes';

import Navigation from './components/Navigation';

Vue.use(VueRouter);
Vue.use(VueParticles);
Vue.use(VueScrollTo);

// Google Analytics
Vue.use(VueAnalytics, {
  id: 'UA-123577449-1',
  router
});

Vue.config.productionTip = false;

// Declare the global components
Vue.component('Navigation', Navigation);

new Vue({
  router,
  render: h => h(App),
  mounted() {
    AOS.init()
  }
}).$mount('#app')
